"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountAddress = void 0;
const bs58check_1 = __importDefault(require("bs58check"));
const buffer_1 = require("buffer/");
/**
 * Representation of an account address, which enforces that it:
 * - Hash length exactly 50
 * - Is a valid base58 string
 */
class AccountAddress {
    constructor(address) {
        if (address.length !== 50) {
            throw new Error('The provided address ' +
                address +
                ' is invalid as its length was not 50');
        }
        try {
            this.decodedAddress = buffer_1.Buffer.from(bs58check_1.default.decode(address).subarray(1));
            this.address = address;
        }
        catch (error) {
            throw error;
        }
    }
    static fromBytes(bytes) {
        return new AccountAddress(bs58check_1.default.encode(buffer_1.Buffer.concat([buffer_1.Buffer.of(1), bytes])));
    }
    toJSON() {
        return this.address;
    }
}
exports.AccountAddress = AccountAddress;
